var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"xt-myself-divider"},[_c('div',{staticClass:"xt-myself-divider-text"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"xt-myself-divider-line"})])
}
var staticRenderFns = []

export { render, staticRenderFns }